import type { URN } from "../../../types";
import type { BetslipExchangeOrder, ExchangeOrdersReadState, ExchangeOrdersState } from "./ExchangeOrders.types";

const NO_ORDERS: ExchangeOrdersState = {};

export const getExchangeOrders = (state: ExchangeOrdersReadState): ExchangeOrdersState =>
  state.exchangeOrders ?? NO_ORDERS;

export const getExchangeOrder = (
  state: ExchangeOrdersReadState,
  market: URN,
  betId: string,
): BetslipExchangeOrder | null =>
  getExchangeOrders(state)[market]?.orders.find((order) => order.betId === betId) ?? null;
